import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";

import { Context, setLoginModalVisible } from "../lib/globalState";
import { useUser, useFirestore } from "../lib/preactfire";
import {
  addOverlay,
  addReplyBox,
  removeOverlay,
  removeReplyBox,
} from "../lib/helper";

export default function CommentsAction({ id, obj }) {
  const { state, dispatch } = useContext(Context);

  const user = useUser();
  const db = useFirestore();

  const updateReaction = (reaction) => {
    document.querySelectorAll(".comment-action-inner").forEach((el) => {
      el.style = "z-index:unset";
    });
    if (user) {
      const commentRef = db.collection("comment").doc(`${id}`);

      if (obj[`${reaction}`]) {
        commentRef.update({
          [`${reaction}`]: [
            ...obj[`${reaction}`],
            {
              user_id: user.uid,
              date: new Date(),
            },
          ],
        });
      } else {
        commentRef.update({
          [`${reaction}`]: [
            {
              user_id: user.uid,
              date: new Date(),
            },
          ],
        });
      }
    } else {
      dispatch(setLoginModalVisible(true));
    }
    removeOverlay();
  };

  return (
    <div className="comment-action-inner">
      {obj?.love?.some((love) => love?.user_id === user?.uid) ? (
        <UserReactionChip reaction="love" color={state.color} />
      ) : obj?.clap?.some((clap) => clap?.user_id === user?.uid) ? (
        <UserReactionChip reaction="clap" color={state.color} />
      ) : obj?.like?.some((like) => like?.user_id === user?.uid) ? (
        <UserReactionChip reaction="like" color={state.color} />
      ) : obj?.dislike?.some((dislike) => dislike?.user_id === user?.uid) ? (
        <UserReactionChip reaction="dislike" color={state.color} />
      ) : (
        // Show React action only when enable in widget settings
        state.commentReaction && (
          <Fragment>
            <a
              href=""
              id={`comment_react_link_${id}`}
              className="comment-react-link"
              onClick={(e) => {
                e.preventDefault();
                addOverlay();
                let reactionwrapper = document.getElementById(
                  `react-icons-${id}`
                );
                if (reactionwrapper.classList.contains("show-action")) {
                  removeOverlay();
                  reactionwrapper.classList.remove("show-action");
                } else {
                  addOverlay();
                  reactionwrapper.classList.add("show-action");
                }
              }}
            >
              <svg viewBox="0 0 512 512" style="height: 12px">
                <path d="M437.02 74.98C388.668 26.63 324.38 0 256 0S123.332 26.63 74.98 74.98 0 187.62 0 256s26.628 132.668 74.98 181.02S187.62 512 256 512s132.668-26.63 181.02-74.98S512 324.38 512 256s-26.628-132.668-74.98-181.02zM256 481.524c-124.354 0-225.524-101.17-225.524-225.524S131.646 30.476 256 30.476 481.524 131.646 481.524 256 380.354 481.524 256 481.524zm-55.378-293.128c-24.953-24.955-65.556-24.953-90.5 0a15.24 15.24 0 0 0 0 21.55c5.952 5.95 15.6 5.95 21.55 0 13.072-13.07 34.34-13.07 47.4 0a15.19 15.19 0 0 0 10.774 4.464c3.9 0 7.8-1.488 10.774-4.464a15.24 15.24 0 0 0 0-21.55zm201.262 0c-24.953-24.953-65.556-24.955-90.5 0a15.24 15.24 0 0 0 0 21.55c5.952 5.95 15.6 5.95 21.55 0 13.07-13.07 34.338-13.072 47.4 0a15.19 15.19 0 0 0 10.774 4.464c3.9 0 7.8-1.488 10.774-4.464a15.24 15.24 0 0 0 0-21.55zm-10.774 78.78H120.9a15.24 15.24 0 0 0-15.238 15.238c0 82.902 67.447 150.35 150.35 150.35s150.35-67.447 150.35-150.35a15.24 15.24 0 0 0-15.238-15.238zM256 402.286c-60.938 0-111.402-45.703-118.9-104.635h237.8c-7.508 58.932-57.972 104.635-118.9 104.635z" />
              </svg>
              <span> React</span>
            </a>

            <div className="react-icons-wrapper" id={`react-icons-${id}`}>
              <span
                className="comment-react-icon reaction-love"
                onClick={() => updateReaction("love")}
              >
                <img
                  src={require("../assets/images/love.svg")}
                  className="comment-react-emoji"
                  style={`background-color: ${state.color}`}
                  height="22"
                  width="22"
                />
              </span>
              <span
                className="comment-react-icon reaction-clap"
                onClick={() => updateReaction("clap")}
              >
                <img
                  src={require("../assets/images/clap.svg")}
                  className="comment-react-emoji"
                  style={`background-color: ${state.color}`}
                  height="22"
                  width="22"
                />
              </span>
              <span
                className="comment-react-icon reaction-like"
                onClick={() => updateReaction("like")}
              >
                <img
                  src={require("../assets/images/like.svg")}
                  className="comment-react-emoji"
                  style={`background-color: ${state.color}`}
                  height="22"
                  width="22"
                />
              </span>
              <span
                className="comment-react-icon reaction-dislike"
                onClick={() => updateReaction("dislike")}
              >
                <img
                  src={require("../assets/images/dislike.svg")}
                  className="comment-react-emoji"
                  style={`background-color: ${state.color}`}
                  height="22"
                  width="22"
                />
              </span>
            </div>
          </Fragment>
        )
      )}
      {/* Show Reply action only when enable in widget settings */}
      {state.reply && (
        <Fragment>
          <a
            onClick={() => {
              const replyBox = document.getElementById(`reply-box-${id}`);
              if (replyBox) {
                if (replyBox.classList.contains("show")) {
                  removeReplyBox(replyBox);
                } else {
                  addReplyBox(replyBox);
                }
                removeOverlay();
              }
              dispatch({
                type: "CHANGE_ID",
                payload: {
                  id,
                  isSelected: !state.isIdSelected,
                },
              });
            }}
            data-id={id}
            className="comment-reply-link"
          >
            <svg height="512" viewBox="0 0 24 24" width="512">
              <path d="M23.25 22a.75.75 0 0 1-.658-.391l-.02-.038C20.328 17.52 16.054 15 11.418 15H10v4.25a.75.75 0 0 1-1.272.538l-8.5-8.25C.082 11.397 0 11.203 0 11s.082-.397.228-.538l8.5-8.25A.75.75 0 0 1 10 2.75v4.252A14.27 14.27 0 0 1 24 21.25a.75.75 0 0 1-.564.727.74.74 0 0 1-.186.023zm-14-8.5h2.168a14.26 14.26 0 0 1 10.764 4.911C20.888 12.742 15.805 8.5 9.75 8.5h-.5a.75.75 0 0 1-.75-.75V4.523L1.827 11 8.5 17.477V14.25a.75.75 0 0 1 .75-.75z" />
            </svg>
            <span> Reply</span>
          </a>
        </Fragment>
      )}

      {/* Show Share action only when enable in widget settings */}
      {state.commentShare && (
        <Fragment>
          <a
            href="#"
            className="comment-share-link"
            id={`comment_share_link_-${id}`}
            onClick={(e) => {
              addOverlay();
              e.preventDefault();
              let sharewrapper = document.getElementById(`share-icons-${id}`);
              if (sharewrapper.classList.contains("show-action")) {
                removeOverlay();
                sharewrapper.classList.remove("show-action");
              } else {
                addOverlay();
                sharewrapper.classList.add("show-action");
              }
            }}
          >
            <svg height="512" viewBox="0 0 482.239 482.239" width="512">
              <path d="M378.902 275.565c-34.183 0-64.306 16.874-83.127 42.52l-94.044-47.033c2.912-9.54 4.943-19.456 4.943-29.934s-2.03-20.397-4.943-29.934l94.044-47.033c18.82 25.647 48.944 42.52 83.127 42.52 56.983 0 103.337-46.354 103.337-103.337S435.886 0 378.902 0 275.565 46.354 275.565 103.337c0 10.478 2.033 20.395 4.945 29.932l-94.047 47.035c-18.82-25.647-48.944-42.52-83.127-42.52C46.353 137.783 0 184.136 0 241.12s46.353 103.337 103.337 103.337c34.183 0 64.306-16.874 83.127-42.52l94.044 47.035c-2.912 9.536-4.943 19.453-4.943 29.932 0 56.983 46.353 103.337 103.337 103.337S482.24 435.886 482.24 378.903s-46.354-103.338-103.337-103.338zm0-241.12c37.995 0 68.89 30.914 68.89 68.89s-30.897 68.89-68.89 68.89-68.89-30.914-68.89-68.89 30.897-68.89 68.89-68.89zM103.337 310.01c-37.995 0-68.89-30.914-68.89-68.89s30.897-68.89 68.89-68.89 68.89 30.914 68.89 68.89-30.896 68.89-68.89 68.89zm275.565 137.782c-37.995 0-68.89-30.914-68.89-68.89s30.897-68.89 68.89-68.89 68.89 30.914 68.89 68.89-30.896 68.89-68.89 68.89z" />
            </svg>
            <span>Share</span>
          </a>
          <div className="share-icons-wrapper" id={`share-icons-${id}`}>
            <span
              className="comment-share-icon share-fb"
              onClick={() => {
                window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}?emotify_comment_id=${id}`,
                  "popUpWindow",
                  "height=520,width=560,left=0,top=0,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes"
                );
              }}
            >
              <img src={require("../assets/images/facebook.svg")} />
            </span>
            <span
              className="comment-share-icon share-twitter"
              onClick={() => {
                window.open(
                  `https://twitter.com/intent/tweet?url=${window.location.href}?emotify_comment_id=${id}`,
                  "popUpWindow",
                  "height=520,width=560,left=0,top=0,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes"
                );
              }}
            >
              <img src={require("../assets/images/twitter.svg")} />
            </span>
            <span
              className="comment-share-icon share-email"
              onClick={() => {
                window.location.href = `mailto:?body=${window.location.href}?emotify_comment_id=${id}`;
              }}
            >
              <img src={require("../assets/images/email.svg")} />
            </span>
            <span className="comment-share-icon share-more">
              <img src={require("../assets/images/more.svg")} />
            </span>
          </div>
        </Fragment>
      )}
    </div>
  );
}

const UserReactionChip = ({ reaction, color }) => (
  <div className="reaction-chip" style={`background-color: ${color}`}>
    <img
      src={require(`../assets/images/${reaction}.svg`)}
      className="reaction-chip-emoji"
      height="14"
      width="14"
    />
    <span className="reaction-chip-text">{reaction}</span>
  </div>
);
